const QUERY_PARAM_NAME = 'referralCode';
const LOCAL_STORE_PREFIX = 'referral_code_';

export const referralCodeKey = (productUUID: string) => {
  return LOCAL_STORE_PREFIX + productUUID;
};

export const storeReferralCodeFromParams = (productUUID: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  const referralCode = urlParams.get(QUERY_PARAM_NAME);
  if (referralCode) {
    localStorage.setItem(referralCodeKey(productUUID), referralCode);
  }
};

export const getReferralCode = (productUUID: string) => {
  return localStorage.getItem(referralCodeKey(productUUID));
};
